export default class HeaderHeight {
  constructor() {
    var header = $('.header')
    var content = $('.content')

    content.css({ 'padding-top': header.height() + 'px' })
  }
}
